import React, { Component } from 'react';
import { connect } from 'react-redux';
import './TypingIndicator.css';

class TypingIndicator extends Component {
    componentDidUpdate(prevProps) {
        const { activeTypingConvIds, conversationId, messageWindow } = this.props;

        const wasVisible = prevProps.activeTypingConvIds.includes(conversationId);
        const isVisible = activeTypingConvIds.includes(conversationId);

        if (!wasVisible && isVisible && messageWindow && messageWindow.current) {
            const container = messageWindow.current;

            const isAtBottom =
                (container.scrollHeight - container.scrollTop - container.clientHeight) < 80;

            if (isAtBottom) {
                container.scrollTop = container.scrollHeight;
            }
        }
    }

    render() {
        const { activeTypingConvIds, conversationId } = this.props;

        if (!activeTypingConvIds.includes(conversationId)) return null;

        return (
            <div className="typing-indicator">
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    activeTypingConvIds: state.chat.activeTypingConvIds,
});

export default connect(mapStateToProps)(TypingIndicator);



// WEBPACK FOOTER //
// ./src/components-new/TypingIndicator.jsx